import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React__default from 'react';
import '../../../../../utils/fetcher.js';
import { prependPrefix } from '../../../../../utils/style.js';
import { useHeaderContext } from '../../../context.js';

var StartBtn = function StartBtn() {
  var _startBtnConfig$confi;

  var _useHeaderContext = useHeaderContext(),
      startBtnConfig = _useHeaderContext.startBtnConfig,
      user = _useHeaderContext.user;

  if (startBtnConfig !== null && startBtnConfig !== void 0 && startBtnConfig.loginRequired && !user) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: prependPrefix('popup')
  }, startBtnConfig === null || startBtnConfig === void 0 ? void 0 : (_startBtnConfig$confi = startBtnConfig.config) === null || _startBtnConfig$confi === void 0 ? void 0 : _mapInstanceProperty(_startBtnConfig$confi).call(_startBtnConfig$confi, function (item) {
    var _context;

    if (item.check && !item.check(user)) {
      return null;
    }

    return /*#__PURE__*/React__default.createElement("ul", {
      key: item.title
    }, /*#__PURE__*/React__default.createElement("span", null, item.title), _mapInstanceProperty(_context = item.links).call(_context, function (link) {
      if (link.check && !link.check(user)) {
        return null;
      }

      if (link.linkItem) {
        var LinkItem = link.linkItem;
        return /*#__PURE__*/React__default.createElement(LinkItem, {
          key: link.text
        });
      }

      return /*#__PURE__*/React__default.createElement("li", {
        key: link.text
      }, /*#__PURE__*/React__default.createElement("a", {
        href: link.href,
        target: "_blank"
      }, link.text));
    }));
  }));
};

export { StartBtn };
